import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../store/app.states';
import { ComponentBase } from '../component-base';
import { OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-pension-view',
  templateUrl: './pension-view.component.html',
  styleUrls: ['./pension-view.component.scss'],
  host: {
    class: 'w-100'
  }
})
export class PensionViewComponent extends ComponentBase implements OnInit, OnDestroy {


  constructor(public store: Store<AppState>,
    private router: Router) {
    super();
  }

  ngOnInit() {
    super.ngOnInitBase();
  }

  ngOnDestroy() {
    super.ngOnDestroyBase();
  }

}
